interface ElementGroup {
  id: number;
  name: string;
  category?: string;
}

interface ElementTag {
  id: number;
  name: string;
  category?: string;
}

export interface ElementProps {
  id: number;
  name: string;
  category: string;
  createdBy: {
    name: string;
    profileImage?: string;
  };
  published: boolean;
  deleted: boolean;
  objectName: string;
  groups: ElementGroup[];
  tags: ElementTag[];
  pro: boolean;
  searchKeyword?: string;
  preview?: string;
}

export enum ElementUseFeature {
  COPILOT_ADD_TO_CANVAS = 'COPILOT_ADD_TO_CANVAS',
  COPILOT_REPLACE_ELEMENT = 'COPILOT_REPLACE_ELEMENT',
  ELEMENTS_TAB_ADD_TO_CANVAS = 'ELEMENTS_TAB_ADD_TO_CANVAS',
  ELEMENTS_TAB_REPLACE_ELEMENT = 'ELEMENTS_TAB_REPLACE_ELEMENT',
  STYLE_SWITCH = 'STYLE_SWITCH',
}
